import { FaSuitcaseRolling, FaBook, FaMap, FaCalendarAlt, FaPercent, FaDumbbell } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
  sub: "Join Our Adventure",
  heading: "Be Part of Our Hiking Community",
  description:
    "Join our hiking community and become a part of a passionate team dedicated to exploring the outdoors. We're looking for individuals who are enthusiastic about hiking, camping, and trekking. Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem enim nobis ea quo sint vero laboriosam ex repellendus.",
  points: [
    "Explore Scenic Trails",
    "Participate in Guided Hikes",
    "Learn Camping Skills",
    "Engage with Fellow Adventurers",
    "Experience Night Treks",
  ],
};

const benefits = [
  {
    id: 1,
    icon: <FaSuitcaseRolling />,
    title: "Quality Gear",
    description: "Get access to top-quality hiking and camping gear at discounted rates, ensuring you're equipped for your outdoor adventures.",
  },
  {
    id: 2,
    icon: <FaBook />,
    title: "Skill Development",
    description: "Participate in workshops and skill development sessions to enhance your hiking, camping, and survival skills, preparing you for any adventure.",
  },
  {
    id: 3,
    icon: <FaMap />,
    title: "Guided Expeditions",
    description: "Join guided expeditions led by experienced adventurers, allowing you to explore new trails and destinations with confidence.",
  },
  {
    id: 4,
    icon: <FaCalendarAlt />,
    title: "Flexible Itineraries",
    description: "Enjoy flexible trip itineraries and scheduling options, making it easier to plan your outdoor adventures around your personal commitments.",
  },
  {
    id: 5,
    icon: <FaPercent />,
    title: "Member Discounts",
    description: "Access exclusive discounts on camping gear, outdoor apparel, and adventure equipment, saving you money on your next expedition.",
  },
  {
    id: 6,
    icon: <FaDumbbell />,
    title: "Wellness Support",
    description: "Benefit from wellness support services, including access to fitness resources, nutrition guides, and mental health resources to keep you fit for the trails.",
  },
];

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Hiking Guide',
        content: 'Join our team as a Hiking Guide and lead outdoor enthusiasts on exciting, scenic hiking trails while ensuring safety and a memorable experience.',
        details: {
            location: 'Fire Camp, 456 Woods Rd',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 2 Years in Outdoor Guiding',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'As a Hiking Guide, you will be responsible for leading groups on various hiking expeditions, ensuring their safety, and enhancing their outdoor experience. This is a fantastic opportunity to work in a beautiful natural setting and share your passion for the outdoors with others.',
        ],
        responsibilities: [
            'Lead hiking tours and ensure safety of all participants.',
            'Prepare and plan hiking routes based on the skill levels of the group.',
            'Provide outdoor knowledge and assist with navigation and survival skills.',
            'Ensure all necessary safety measures are in place and address any emergencies.',
            'Maintain equipment and ensure the proper use of outdoor gear.',
        ],
        qualifications: [
            'Experience in leading hiking tours and outdoor activities.',
            'In-depth knowledge of hiking trails and outdoor survival skills.',
            'Strong leadership and communication skills.',
            'Ability to work in challenging outdoor conditions.',
            'Certification in wilderness first aid or similar safety training is a plus.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Campsite Manager',
        content: 'Join our team as a Campsite Manager to oversee the operations of our camp, ensuring a safe and enjoyable experience for all campers.',
        details: {
            location: 'Fire Camp, 456 Woods Rd',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 3 Years in Campsite or Hospitality Management',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'As a Campsite Manager, you will be responsible for the overall management of the campsite, including staff supervision, customer service, and maintenance. This is an exciting role for someone passionate about outdoor recreation and hospitality.',
        ],
        responsibilities: [
            'Oversee daily operations of the campsite and ensure smooth guest experiences.',
            'Supervise campsite staff and ensure they are trained and motivated.',
            'Handle customer inquiries, bookings, and complaints efficiently.',
            'Ensure that the campsite facilities are well-maintained and stocked.',
            'Coordinate outdoor activities and events for guests.',
        ],
        qualifications: [
            'Proven experience in campsite or hospitality management.',
            'Strong leadership, organizational, and communication skills.',
            'Ability to manage a team and handle diverse situations.',
            'Customer service-oriented with a focus on creating positive experiences.',
            'Familiarity with outdoor activities and campsite logistics.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Wilderness Survival Instructor',
        content: 'Join our team as a Wilderness Survival Instructor and teach vital survival skills to adventurers and outdoor enthusiasts.',
        details: {
            location: 'Fire Camp, 456 Woods Rd',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 3 Years in Wilderness Survival Instruction',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'As a Wilderness Survival Instructor, you will teach essential survival skills such as fire-making, shelter-building, navigation, and first-aid in a wilderness setting. This is an excellent opportunity to share your expertise with those passionate about the outdoors.',
        ],
        responsibilities: [
            'Teach wilderness survival techniques in both classroom and field settings.',
            'Plan and lead survival training sessions and outdoor expeditions.',
            'Ensure the safety and well-being of participants during training.',
            'Assess and evaluate students’ skills and progress throughout the course.',
            'Maintain survival equipment and ensure all necessary supplies are available.',
        ],
        qualifications: [
            'Proven experience in wilderness survival instruction or outdoor education.',
            'Expert knowledge of survival techniques and outdoor first-aid.',
            'Ability to teach and lead outdoor groups of varying skill levels.',
            'Strong communication and leadership skills.',
            'Ability to work independently and in remote outdoor environments.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Trail Maintenance Worker',
        content: 'Join our team as a Trail Maintenance Worker to maintain and enhance hiking trails, ensuring safe and enjoyable experiences for all adventurers.',
        details: {
            location: 'Fire Camp, 456 Woods Rd',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 2 Years in Trail Maintenance or Landscaping',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'As a Trail Maintenance Worker, you will be responsible for the upkeep of hiking and outdoor trails, ensuring they are safe, accessible, and well-maintained. This role is perfect for those passionate about preserving nature and enhancing outdoor experiences.',
        ],
        responsibilities: [
            'Inspect and maintain hiking trails to ensure they are clear and safe for use.',
            'Repair and rebuild trail sections, including bridges and barriers as needed.',
            'Clear debris and vegetation that may obstruct the trail.',
            'Maintain and install trail signage to ensure clear navigation.',
            'Collaborate with other team members and contractors on larger projects.',
        ],
        qualifications: [
            'Experience in trail maintenance, landscaping, or similar outdoor work.',
            'Ability to work with tools and machinery used for trail maintenance.',
            'Strong physical stamina and ability to work in various weather conditions.',
            'Knowledge of environmental preservation and safety standards.',
            'Ability to work independently and as part of a team.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Outdoor Education Coordinator',
        content: 'Join our team as an Outdoor Education Coordinator to develop and lead outdoor educational programs that inspire and educate participants on environmental conservation and outdoor skills.',
        details: {
            location: 'Fire Camp, 456 Woods Rd',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 3 Years in Outdoor Education or Environmental Education',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'As the Outdoor Education Coordinator, you will be responsible for creating and leading outdoor education programs that engage participants with nature and foster a deeper understanding of environmental stewardship.',
        ],
        responsibilities: [
            'Design, implement, and lead outdoor education programs and workshops.',
            'Coordinate with local schools, organizations, and community groups to offer educational outdoor experiences.',
            'Ensure all activities meet safety and environmental guidelines.',
            'Monitor and evaluate program success and participant engagement.',
            'Develop educational materials and resources for participants.',
        ],
        qualifications: [
            'Experience in outdoor education or environmental education.',
            'Strong leadership and communication skills.',
            'Knowledge of outdoor safety protocols and environmental education practices.',
            'Ability to work with diverse groups of participants and adapt to different age groups.',
            'Creative and enthusiastic about fostering environmental awareness and outdoor skills.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Adventure Tour Guide',
        content: 'Join our team as an Adventure Tour Guide to lead thrilling outdoor expeditions and provide memorable experiences for participants in diverse natural landscapes.',
        details: {
            location: 'Fire Camp, 456 Woods Rd',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 2 Years in Adventure Tour Guiding or Related Outdoor Leadership Roles',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$60K - $75K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'As an Adventure Tour Guide, you will be responsible for leading guided tours in challenging and scenic environments, ensuring participant safety while offering educational and adventurous experiences.',
        ],
        responsibilities: [
            'Lead and guide participants on outdoor adventures such as hiking, camping, and trekking tours.',
            'Ensure the safety of all participants by maintaining a strong knowledge of outdoor safety practices and emergency response procedures.',
            'Provide engaging and informative commentary about the natural surroundings, history, and environmental conservation.',
            'Ensure that all equipment and logistics for the tours are prepared and maintained.',
            'Promote a positive and enjoyable experience for all tour participants, ensuring a memorable adventure.',
        ],
        qualifications: [
            'Previous experience as an adventure tour guide or in an outdoor leadership role.',
            'In-depth knowledge of outdoor activities, landscapes, and environmental safety.',
            'Ability to engage and interact with diverse groups of participants.',
            'Strong communication and interpersonal skills.',
            'Ability to manage risks and respond effectively to emergencies in outdoor environments.',
        ],
    }

];

export { positions, benefits, careerIntro };